// Gets the GA tracking code for the site.
const getCookie = (cookieKey: string): string => {
	const cookieString = document.cookie;
	const cookies = cookieString.split("; ");
	for (let i = 0; i < cookies.length; i++) {
		const [key, value] = cookies[i].split("=");
		if (key === cookieKey) {
			return value;
		}
	}
	return "";
};

export default getCookie;
